export const HealthReportPage: React.FC = () => {
    return <section className="coming-soon-page page-content-padding">
        <div className="coming-soon-content">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
            </svg>
            <h2>Health Report</h2>
            <p>Coming soon</p>
        </div>
    </section>
}
